import AttachmentModel from "./AttachmentModel";
export default class AssessmentModel {
  id: number;
  work_orders_id: number;
  issue_description: string | null;
  root_cause: string | null;
  attachments: AttachmentModel[];
  status: string;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  workorder: any;

  constructor(data: any = {}) {
      this.id = data.id || 0;
      this.work_orders_id = data.work_orders_id || 0;
      this.issue_description = data.issue_description || null;
      this.root_cause = data.root_cause || null;
      this.attachments = data.attachments || [];
      this.status = data.status || "draft";
      this.deleted_at = data.deleted_at || null;
      this.created_at = data.created_at || "";
      this.updated_at = data.updated_at || "";
      this.workorder = data.workorder || {};
  }
}